import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Popup from 'reactjs-popup';
import { Button } from '@piplapps/pipl-ui';
import { connect } from 'react-redux';
import styles from './SendRemindersModal.module.less';
import { UsersSelectors } from '../../../Redux/modules/users/selectors';
import AnalyticsHandler from '../../../Utils/AnalyticsHandler/AnalyticsHandler';
import AnalyticsEventNames from '../../../Utils/AnalyticsHandler/AnalyticsEventNames';

const SendRemindersModal = (props) => {
  const getModalStyle = () => {
    return {
      width: '700px',
      boxShadow: 'rgba(101, 101, 101, 0.28) 0px 4px 12px 0px',
      border: 'none',
      borderRadius: '8px',
      padding: '40px 80px',
      backgroundColor: '#ffffff',
    };
  };

  const [reminders, setReminders] = useState([]);
  useEffect(() => {
    setReminders(props.remindersToSend);
  }, [props.remindersToSend]);

  return (
    <>
      <Popup
        contentStyle={getModalStyle()}
        modal
        open={props.open}
        onClose={() => {
          setReminders(props.remindersToSend);
          props.onClose();
        }}
        closeOnDocumentClick={false}
      >
        {() => (
          <div className={styles.modalContainer}>
            <div className={styles.header}>{gettext('Send Reminders')}</div>
            <span
              tabIndex={0}
              role="button"
              className={styles.close}
              onClick={() => {
                props.onClose();
              }}
            >
              &times;
            </span>
            <div className={styles.text}>
              {gettext('Are you sure you want to send reminders to the following users?')}
            </div>
            <div className={styles.usersContainer}>
              {reminders.map((user) => {
                return (
                  <div
                    role="button"
                    tabIndex={-1}
                    className={styles.emailPicker}
                    id={user.email}
                    key={user.email}
                    onClick={() => setReminders(reminders.filter((u) => u.email !== user.email))}
                  >{`${user.email}  X`}</div>
                );
              })}
            </div>

            <div className={styles.buttonContainer}>
              <div className={styles.buttonWrapper}>
                <AnalyticsHandler eventName={AnalyticsEventNames.SENT_REMINDERS_SUBMIT}>
                  <Button
                    id="submit-button"
                    buttonClass="primary-blue"
                    type="submit"
                    onClick={() => props.sendReminders(reminders)}
                    text={gettext('Send Reminder')}
                    disabled={reminders.length === 0}
                    isLoading={props.isLoading}
                    loadingText={gettext('Sending')}
                  />
                </AnalyticsHandler>
              </div>
              <div className={styles.buttonWrapper}>
                <Button
                  buttonClass="secondary-blue"
                  onClick={() => props.onClose()}
                  text={gettext('Cancel')}
                  id="cancel-button"
                />
              </div>
            </div>
          </div>
        )}
      </Popup>
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    remindersToSend: UsersSelectors.remindersToSendSelector(state),
    isLoading: UsersSelectors.isLoadingRemindersSelector(state),
  };
};

SendRemindersModal.propTypes = {
  onClose: PropTypes.func,
  open: PropTypes.bool,
  remindersToSend: PropTypes.array,
  sendReminders: PropTypes.func,
  isLoading: PropTypes.bool,
};

export default connect(mapStateToProps, null)(SendRemindersModal);
